/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientJoinLogDto } from '../../models/client-join-log-dto';

export interface ClientWorkspaceJoinLogControllerAcceptJoinRequest$Params {

/**
 * 가입 요청 ID
 */
  joinId: string;

/**
 * 워크스페이스 ID
 */
  id: string;
}

export function clientWorkspaceJoinLogControllerAcceptJoinRequest(http: HttpClient, rootUrl: string, params: ClientWorkspaceJoinLogControllerAcceptJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientJoinLogDto>> {
  const rb = new RequestBuilder(rootUrl, clientWorkspaceJoinLogControllerAcceptJoinRequest.PATH, 'patch');
  if (params) {
    rb.path('joinId', params.joinId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientJoinLogDto>;
    })
  );
}

clientWorkspaceJoinLogControllerAcceptJoinRequest.PATH = '/api/clientWorkspaceJoinLog/{id}/join/{joinId}/accept';
